import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { findAll, remove } from './api-curso';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useDispatch, useSelector } from 'react-redux';
import { setCurso, setCursos, removeCursos } from './actions/actions';


const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    actionIcon: {
        cursor: 'pointer',
        marginRight: '10px'
    },
    cursorLink: {
        cursor: 'pointer'
    },
    novoRegistro: {
        marginTop: '10px',
        marginBottom: '10px',
    },
});



export default function CursoTable() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const cursos = useSelector(state => state.cursos);

    useEffect(() => {
        findAll().then((data) => {
            if (data) {
                dispatch(setCursos(data));
            }
        })
    }, [dispatch]);

    const handleDelete = (index) => {
        confirmAlert({
            title: 'Alerta',
            message: 'Deseja deletar este Curso?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => {
                        remove(cursos[index].codCurso).then((data) => {
                            if (data) {
                                dispatch(removeCursos(cursos[index].codCurso));
                            } else {
                                handleDeleteError();
                            }

                        });
                    }
                },
                {
                    label: 'Não',
                    onClick: () => { }
                }
            ]
        });
    };

    const handleDeleteError = () => {
        confirmAlert({
            title: 'Erro',
            message: 'O Curso não pode ser removido pois possui turmas cadastradas. Remova todas as turmas cadastradas com este curso.',
            buttons: [
                {
                    label: 'Ok',
                    onClick: () => { }
                }
            ]
        });
    }

    const handleEdit = (curso) => {
        dispatch(setCurso(curso));
    }


    return (
        <div>
            <Button
                variant="contained"
                onClick={() => dispatch(setCurso({ eNovo: true }))}
                color="primary"
                className={classes.novoRegistro}>
                Novo Curso
            </Button>
            <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell>Descrição</TableCell>
                        <TableCell>Abreviação</TableCell>
                        <TableCell>Ações</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {cursos && cursos.map((curso, index) => (
                        <TableRow key={index}>
                            <TableCell>{curso.descricao}</TableCell>
                            <TableCell>{curso.abreviacao}</TableCell>
                            <TableCell>
                                <EditIcon
                                    fontSize='small'
                                    onClick={() => handleEdit(curso)}
                                    color="secondary"
                                    className={classes.actionIcon}
                                />
                                <DeleteIcon
                                    fontSize='small'
                                    className={classes.actionIcon}
                                    onClick={() => { handleDelete(index) }} color="secondary"
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

        </div>
    );
}